'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _description = require('./description.html');

var _description2 = _interopRequireDefault(_description);

var _description3 = require('./description.controller');

var _description4 = _interopRequireDefault(_description3);

require('./description.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var descriptionComponent = {
  bindings: {
    item: "=",
    language: "<",
    model: "<",
    modelName: "<"
  },
  template: _description2.default,
  controller: _description4.default,
  controllerAs: "vm"
};

exports.default = descriptionComponent;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/description/description.component.js